import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

export const AdditionalCtasWrapper = styled.section`
  width: 100%;
  border-top: 3px solid ${COLORS.grey15};
  padding-top: 40px;
  margin-top: 40px;
  @media ${device.tablet} {
    padding-top: 48px;
    margin-top: 48px;
  }
  @media ${device.laptop} {
    padding-top: 60px;
    margin-top: 60px;
  }
  @media ${device.laptopL} {
    padding-top: 80px;
    margin-top: 80px;
  }
`;
export const Title = styled.h1`
  font-family: Audi Type;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px; /* 150% */
  letter-spacing: 0.003px;
`;
export const ContentWrapper = styled.div`
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  gap: 40px;

  @media (min-width: 1280px) {
    flex-direction: row;
  }
`;

export const AdditionaBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const ImageContainer = styled.div``;
export const ImageForCta = styled.img`
  width: 100%;
  height: 100%;
`;
export const SubTitle = styled.h2`
  padding-top: 20px;
  font-family: Audi Type;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
  letter-spacing: 0.002px;

  @media ${device.tablet} {
    padding-top: 36px;
  }
  @media ${device.laptop} {
    padding-top: 24px;
  }
  @media ${device.laptopL} {
    padding-top: 38px;
  }
`;
export const TextForCta = styled.p`
  padding-top: 6px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;

  @media ${device.tablet} {
    padding-top: 12px;
  }
  @media ${device.laptop} {
    padding-top: 14px;
  }
  @media ${device.laptopL} {
    padding-top: 46px;
  }
`;
export const Cta = styled.a`
  color: ${COLORS.black};
  margin-top: 52px;
  display: flex;
  width: 168px;
  height: 56px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${COLORS.black};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
  cursor: pointer;
`;
